import React, { Component } from 'react';
import proptypes from 'prop-types';
import queryString from 'qs';
import Spinner from '../../Spinner';
import { OpenModalButton } from '../../Modal';
import FullscreenModal from '../../Modal/fullscreen-modal';
import CONSTANTS from '../../Pages/findcare/constants';
import Map from './map2';

export function getBoundaryQuery(map, api) {
  const bounds = map.getBounds();
  const ne = bounds.getNorthEast(); // LatLng of the north-east corner
  const sw = bounds.getSouthWest(); // LatLng of the south-west corder
  const nw = new api.maps.LatLng(ne.lat(), sw.lng());
  const se = new api.maps.LatLng(sw.lat(), ne.lng());
  return `${nw.lng()}|${nw.lat()}|${se.lng()}|${se.lat()}`;
}

class MapControls extends Component {
  translations = this.props.Translations;

  /**
   * Constructs the query as a query string object.
   * Pushes to history so that the map component will recognise the update
   * and do a search for `api/hjv/pins` in `componentWillUpdate`.
   *
   * The list `api/hjv/search` is done from `withSearch` container
   * called from the list component.
   */
  searchWithBoundaries() {
    if (this.props.isLoading === true) {
      return false;
    }
    if (typeof this.props.googleAPI !== 'undefined') {
      //search query
      const qs = queryString.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      });
      const boundaryQuery = getBoundaryQuery(
        this.props.map,
        this.props.googleAPI
      );
      const zoom = this.props.map.getZoom();
      const center = this.props.map.getCenter().toJSON();
      delete qs.p;
      delete qs.location;
      delete qs.region;
      delete qs.heading;
      delete qs.g;
      delete qs.m;
      delete qs.nearby;
      qs.b = boundaryQuery;
      qs.z = zoom;
      qs.mlat = center.lat;
      qs.mlng = center.lng;

      this.props.history.push(
        `${this.props.location.pathname}?${queryString.stringify(qs)}`
      );

      //When boundarySearch is clicked, location inout field should be cleared
      let locationClearButton = document.querySelectorAll(
        '#field_location>.findcare-search__field__query>.findcare-searchfield__clear-field'
      )[0];
      locationClearButton && locationClearButton.click();
    }
  }

  zoomIn() {
    this.props.map.setZoom(this.props.map.getZoom() + 1);
  }

  zoomOut() {
    this.props.map.setZoom(this.props.map.getZoom() - 1);
  }

  render() {
    const {
      zoom,
      boundarySearch,
      expand,
      plannerLink,
      plannerLinkText,
      lat,
      lng,
      ...props
    } = this.props;

    return (
      <div className="findcare-map__map__controls">
        {expand && (
          <div>
            <OpenModalButton
              className="findcare-map__map__controls__expand"
              id="searchmap"
              fullScreen={true}
            >
              <span className="show-for-sr">Expandera karta</span>
            </OpenModalButton>
            <FullscreenModal id="searchmap" classModifier="findcare-fullscreen">
              <Map
                {...props}
                modifiers={{ 'findcare-map__gmap--modal': true }}
                expand={false}
              />
            </FullscreenModal>
          </div>
        )}

        {boundarySearch && (
          <button
            disabled={boundarySearch === CONSTANTS.BOUNDARY_QUERY_DISABLED}
            className="findcare-map__map__controls__boundaries"
            onClick={() => this.searchWithBoundaries()}
          >
            <span className="findcare-map__map__controls__boundaries__text">
              {this.translations.searchinarea}
            </span>
            <Spinner Modifiers={{ 'c-spinner--map': true }} />
          </button>
        )}
        {zoom && (
          <div className="findcare-map__map__controls__zoom">
            <button
              type="button"
              className="findcare-map__map__controls__zoom-out"
              onClick={() => this.zoomOut()}
            >
              <span className="show-for-sr">Zooma ut</span>
            </button>
            <button
              type="button"
              className="findcare-map__map__controls__zoom-in"
              onClick={() => this.zoomIn()}
            >
              <span className="show-for-sr">Zooma in</span>
            </button>
          </div>
        )}

        {plannerLink && (
          <a
            className="findcare-map__map__controls__planner-link"
            href={`https://www.google.se/maps/dir/?api=1&destination=${lat},${lng}`}
          >
            <span>{plannerLinkText}</span>
          </a>
        )}
      </div>
    );
  }
}

MapControls.propTypes = {
  Translations: proptypes.shape({
    searchinarea: proptypes.string,
  }),
  EnableSearchClosestUnits: proptypes.bool,
  location: proptypes.object,
  isLoading: proptypes.bool,
  map: proptypes.object,
  googleAPI: proptypes.object,
  zoom: proptypes.bool,
  boundarySearch: proptypes.oneOfType([proptypes.string, proptypes.bool]),
  expand: proptypes.bool,
  plannerLink: proptypes.bool,
  plannerLinkText: proptypes.string,
  lat: proptypes.number,
  lng: proptypes.number,
};

export default MapControls;
